import React from 'react'

// eslint-disable-next-line @typescript-eslint/ban-types
const overrideRequired = <TProps extends {}>(name: string) => {
  let actualComponent: React.ComponentType<TProps>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name
  const NewComponent = React.forwardRef<any, TProps>((props, ref) => {
    if (!actualComponent) {
      throw new Error(
        `The required component "${name}" has not been configured`,
      )
    }
    const Component = actualComponent
    return <Component {...props} ref={ref} />
  })
  const override = function override<T>(
    newComp: React.ComponentType<TProps> & T,
  ): void {
    actualComponent = newComp
    OverridableComponent.displayName = `Overridden(${name})`
  }

  const OverridableComponent = NewComponent as typeof NewComponent & {
    override: typeof override
  }
  OverridableComponent.displayName = `Overridable(${name})`
  OverridableComponent.override = override
  return OverridableComponent
}

export default overrideRequired
